var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 540,
    height: 255,
    viewBox: "0 0 540 255",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_12546",
    "data-name": "Rectangle 12546",
    width: 540,
    height: 255,
    transform: "translate(405 183)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location",
    transform: "translate(-405 -183)",
    opacity: 0.8,
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Address-bro",
    transform: "translate(405 233.157)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "freepik--Buildings--inject-1--inject-297",
    transform: "translate(0 0.001)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46387",
    "data-name": "Path 46387",
    d: "M95.313,388.353V374.068h15.935V346.352h22.9V233.78h21.9v68.044h19.912V277.466h26.874v63h10.951v20.158h25.879v-7.558h-7.956v-4.2h32.852v5.042h-3.99v21.843H277.5v-41.17h59.726v29.4h42.82V342.14h15.923v24.37h33.846V364.1h13.934V348.984h24.9v26.768h24.885v15.116H509.45v46.2h-445V388.353Z",
    transform: "translate(-64.45 -233.78)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11397",
    "data-name": "Rectangle 11397",
    width: 5.382,
    height: 5.382,
    transform: "translate(371.083 132.859)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11398",
    "data-name": "Rectangle 11398",
    width: 5.382,
    height: 5.382,
    transform: "translate(371.083 144.079)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11399",
    "data-name": "Rectangle 11399",
    width: 5.382,
    height: 5.382,
    transform: "translate(371.083 155.298)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11402",
    "data-name": "Rectangle 11402",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 121.651)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11403",
    "data-name": "Rectangle 11403",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 121.651)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11404",
    "data-name": "Rectangle 11404",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 132.859)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11405",
    "data-name": "Rectangle 11405",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 132.859)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11406",
    "data-name": "Rectangle 11406",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 144.079)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11407",
    "data-name": "Rectangle 11407",
    width: 5.382,
    height: 5.382,
    transform: "translate(419.074 150.361)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11408",
    "data-name": "Rectangle 11408",
    width: 5.382,
    height: 5.382,
    transform: "translate(341.472 138.241)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11409",
    "data-name": "Rectangle 11409",
    width: 5.382,
    height: 5.382,
    transform: "translate(330.708 138.241)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11410",
    "data-name": "Rectangle 11410",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 6.353)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11411",
    "data-name": "Rectangle 11411",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 6.353)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11412",
    "data-name": "Rectangle 11412",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 17.573)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11413",
    "data-name": "Rectangle 11413",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 17.573)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11414",
    "data-name": "Rectangle 11414",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 28.792)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11415",
    "data-name": "Rectangle 11415",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 28.792)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11416",
    "data-name": "Rectangle 11416",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 40)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11417",
    "data-name": "Rectangle 11417",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 40)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11418",
    "data-name": "Rectangle 11418",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 51.22)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11419",
    "data-name": "Rectangle 11419",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 51.22)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11420",
    "data-name": "Rectangle 11420",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 62.428)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11421",
    "data-name": "Rectangle 11421",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 62.428)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11422",
    "data-name": "Rectangle 11422",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 73.648)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11423",
    "data-name": "Rectangle 11423",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 73.648)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11424",
    "data-name": "Rectangle 11424",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 84.868)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11425",
    "data-name": "Rectangle 11425",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 84.868)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11426",
    "data-name": "Rectangle 11426",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 96.076)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11427",
    "data-name": "Rectangle 11427",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 96.076)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11428",
    "data-name": "Rectangle 11428",
    width: 5.382,
    height: 5.382,
    transform: "translate(128.39 96.076)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11429",
    "data-name": "Rectangle 11429",
    width: 5.382,
    height: 5.382,
    transform: "translate(116.725 96.076)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11430",
    "data-name": "Rectangle 11430",
    width: 5.382,
    height: 5.382,
    transform: "translate(105.061 96.076)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11431",
    "data-name": "Rectangle 11431",
    width: 5.382,
    height: 5.382,
    transform: "translate(128.39 120.305)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11432",
    "data-name": "Rectangle 11432",
    width: 5.382,
    height: 5.382,
    transform: "translate(116.725 120.305)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11433",
    "data-name": "Rectangle 11433",
    width: 5.382,
    height: 5.382,
    transform: "translate(105.061 120.305)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11434",
    "data-name": "Rectangle 11434",
    width: 5.382,
    height: 5.382,
    transform: "translate(128.39 144.523)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11435",
    "data-name": "Rectangle 11435",
    width: 5.382,
    height: 5.382,
    transform: "translate(116.725 144.523)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11436",
    "data-name": "Rectangle 11436",
    width: 5.382,
    height: 5.382,
    transform: "translate(105.061 144.523)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11437",
    "data-name": "Rectangle 11437",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 107.296)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11438",
    "data-name": "Rectangle 11438",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 107.296)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11439",
    "data-name": "Rectangle 11439",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 118.504)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11440",
    "data-name": "Rectangle 11440",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 118.504)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11441",
    "data-name": "Rectangle 11441",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 129.723)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11442",
    "data-name": "Rectangle 11442",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 129.723)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11443",
    "data-name": "Rectangle 11443",
    width: 5.382,
    height: 5.382,
    transform: "translate(64.686 118.504)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11444",
    "data-name": "Rectangle 11444",
    width: 5.382,
    height: 5.382,
    transform: "translate(52.121 118.504)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11445",
    "data-name": "Rectangle 11445",
    width: 5.382,
    height: 5.382,
    transform: "translate(64.686 129.279)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11446",
    "data-name": "Rectangle 11446",
    width: 5.382,
    height: 5.382,
    transform: "translate(52.121 129.279)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11447",
    "data-name": "Rectangle 11447",
    width: 5.382,
    height: 5.382,
    transform: "translate(64.686 140.042)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11448",
    "data-name": "Rectangle 11448",
    width: 5.382,
    height: 5.382,
    transform: "translate(52.121 140.042)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11449",
    "data-name": "Rectangle 11449",
    width: 5.382,
    height: 5.382,
    transform: "translate(64.686 150.806)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11450",
    "data-name": "Rectangle 11450",
    width: 5.382,
    height: 5.382,
    transform: "translate(52.121 150.806)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11451",
    "data-name": "Rectangle 11451",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 140.943)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11452",
    "data-name": "Rectangle 11452",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 140.943)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11453",
    "data-name": "Rectangle 11453",
    width: 5.382,
    height: 5.382,
    transform: "translate(82.633 152.151)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11454",
    "data-name": "Rectangle 11454",
    width: 5.382,
    height: 5.382,
    transform: "translate(75.906 152.151)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11455",
    "data-name": "Rectangle 11455",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 144.079)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11456",
    "data-name": "Rectangle 11456",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 155.298)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11457",
    "data-name": "Rectangle 11457",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 155.298)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11458",
    "data-name": "Rectangle 11458",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 166.506)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11459",
    "data-name": "Rectangle 11459",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 166.506)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11460",
    "data-name": "Rectangle 11460",
    width: 5.382,
    height: 5.382,
    transform: "translate(394.4 177.726)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11461",
    "data-name": "Rectangle 11461",
    width: 5.382,
    height: 5.382,
    transform: "translate(383.192 177.726)",
    fill: "#374955"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46388",
    "data-name": "Path 46388",
    d: "M321.27,391.756V413.95h44.856V369.82H321.27V387.8",
    transform: "translate(-221.591 -210.661)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46389",
    "data-name": "Path 46389",
    d: "M391.82,404.225v6.7h44.867V387.6h-9.266",
    transform: "translate(-374.692 -207.639)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46390",
    "data-name": "Path 46390",
    d: "M434.548,387.6H404.41v12.986",
    transform: "translate(-387.282 -207.639)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46391",
    "data-name": "Path 46391",
    d: "M168.319,387.6H136.45v23.329h44.867V387.6h-8.739",
    transform: "translate(179.447 -207.639)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46392",
    "data-name": "Path 46392",
    d: "M81.279,387.6H77.02v23.329h16.6V387.6h-9",
    transform: "translate(336.672 -207.639)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11462",
    "data-name": "Rectangle 11462",
    width: 7.172,
    height: 44.13,
    transform: "translate(118.527 159.159)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46393",
    "data-name": "Path 46393",
    d: "M306.56,376.644H313.6V364.98H289.83v11.664h10.342",
    transform: "translate(-132.285 -211.483)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11463",
    "data-name": "Rectangle 11463",
    width: 27.365,
    height: 9.874,
    transform: "translate(300.196 145.424)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11464",
    "data-name": "Rectangle 11464",
    width: 2.691,
    height: 57.865,
    transform: "translate(311.86 145.424)",
    fill: "none",
    stroke: "#2e353a",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-1--inject-297",
    transform: "translate(393.164 139.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46394",
    "data-name": "Path 46394",
    d: "M140.447,57.63a19.447,19.447,0,0,1,19.447,19.447c0,9.7-17.94,32.562-17.94,32.562h-1.508S121,87.816,121,77.077A19.447,19.447,0,0,1,140.447,57.63Zm0,28.944a9.5,9.5,0,1,0-9.5-9.5,9.5,9.5,0,0,0,9.5,9.5Z",
    transform: "translate(-121 -57.63)",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46395",
    "data-name": "Path 46395",
    d: "M130.447,57.63a19.447,19.447,0,0,1,19.447,19.447c0,10.739-19.447,32.562-19.447,32.562S111,87.816,111,77.077A19.447,19.447,0,0,1,130.447,57.63Zm0,28.944a9.5,9.5,0,1,0-9.5-9.5,9.5,9.5,0,0,0,9.5,9.5Z",
    transform: "translate(-109.492 -57.63)",
    fill: "#00be85",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-1--inject-297-2",
    "data-name": "freepik--Location--inject-1--inject-297",
    transform: "translate(49.203 139.819)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46394-2",
    "data-name": "Path 46394",
    d: "M140.447,57.63a19.447,19.447,0,0,1,19.447,19.447c0,9.7-17.939,32.562-17.939,32.562h-1.507S121,87.816,121,77.077A19.447,19.447,0,0,1,140.447,57.63Zm0,28.944a9.5,9.5,0,1,0-9.5-9.5,9.5,9.5,0,0,0,9.5,9.5Z",
    transform: "translate(-121 -57.63)",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46395-2",
    "data-name": "Path 46395",
    d: "M130.447,57.63a19.447,19.447,0,0,1,19.447,19.447c0,10.739-19.447,32.562-19.447,32.562S111,87.816,111,77.077A19.447,19.447,0,0,1,130.447,57.63Zm0,28.944a9.5,9.5,0,1,0-9.5-9.5,9.5,9.5,0,0,0,9.5,9.5Z",
    transform: "translate(-109.492 -57.63)",
    fill: "#0078d7",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Location--inject-1--inject-297-3",
    "data-name": "freepik--Location--inject-1--inject-297",
    transform: "translate(212.583 123.279)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_46394-3",
    "data-name": "Path 46394",
    d: "M148.729,57.63a27.73,27.73,0,0,1,27.729,27.73c0,13.833-25.58,46.432-25.58,46.432h-2.15S121,100.674,121,85.36A27.73,27.73,0,0,1,148.729,57.63Zm0,41.273A13.543,13.543,0,1,0,135.187,85.36,13.542,13.542,0,0,0,148.729,98.9Z",
    transform: "translate(-121 -57.63)",
    fill: "#2e353a",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46395-3",
    "data-name": "Path 46395",
    d: "M138.729,57.63a27.73,27.73,0,0,1,27.729,27.73c0,15.314-27.729,46.432-27.729,46.432S111,100.674,111,85.36A27.73,27.73,0,0,1,138.729,57.63Zm0,41.273A13.543,13.543,0,1,0,125.187,85.36,13.542,13.542,0,0,0,138.729,98.9Z",
    transform: "translate(-108.85 -57.63)",
    fill: "#eb9929",
    stroke: "#2e353a",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_11374",
    "data-name": "Rectangle 11374",
    width: 390,
    height: 2,
    rx: 1,
    transform: "translate(405 436.447)",
    fill: "#e3e5e8",
    opacity: 0
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.6d58c68482dc8d72084fe93fb57bc7a1.svg";
export { ForwardRef as ReactComponent };